import { useCallback, useState } from 'react';
export const useControllableState = ({ initialState, stateProp, }) => {
    const [state, setState] = useState(initialState);
    const returnedState = stateProp !== undefined ? stateProp : state;
    const returnedSetState = useCallback((nextState) => {
        if (stateProp !== undefined) {
            return;
        }
        setState(nextState);
    }, [state, stateProp]);
    return [returnedState, returnedSetState];
};
//# sourceMappingURL=useControlledState.js.map